import React from 'react';
import './NewsPage.css';
import NewsSection from '../components/sections/NewsSection';
import ContactSection from '../components/sections/ContactSection';

const NewsPage = () => {
  return (
    <>
      <div className="news-page-hero">
        <div className="container">
          <div className="news-page-hero-content">
            <h1 className="news-page-title">News & Insights</h1>
            <p className="news-page-subtitle">
              Stay informed about BayPine's latest developments, investments, and industry insights.
            </p>
          </div>
        </div>
      </div>
      <NewsSection />
      <ContactSection />
    </>
  );
};

export default NewsPage;
